module.exports = __webpack_public_path__ + "img/kaizer-chiefs-logo-icon.a12aa683.png";